import Vue from "vue";
import axios from "axios";
import configuration from "@/utils/configuration";
import { handleError } from "@/utils/errorHandler";
import { executeAction } from "@/services/api/helpers";
import { profileService } from "@/services/api/features/profileService";

const profileModules = {
  namespaced: true,

  state: {
    user: JSON.parse(localStorage.getItem("user")) || null,
    loading: {},
    error: {},
    schoolList: [],
    classList: [],
  },
  getters: {
    getUser: (state) => state.user,
    getSchoolList: (state) => state.schoolList,
    getClassList: (state) => state.classList,
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
  },
  mutations: {
    SET_LOADING(state, { action, status }) {
      Vue.set(state.loading, action, status);
    },
    SET_ERROR(state, { action, message }) {
      Vue.set(state.error, action, message);
    },
    SET_USER(state, user) {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
    CLEAR_ERROR(state, action) {
      Vue.set(state.error, action, null);
    },
    SET_SCHOOL(state, schoolList) {
      state.schoolList = schoolList;
    },
    SET_CLASS(state, classList) {
      state.classList = classList;
    },
    SET_RELATIONSHIP(state, relationship) {
      state.relationship = relationship;
    },
    CLEAR_ALL_ERRORS(state) {
      state.error = {};
    },
  },
  actions: {
    async getUserProfile({ commit }) {
      const action = "getUserProfile";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/users/current-user`,
          withCredentials: true,
        });
        commit("SET_USER", data.data);
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    //  GET USER BY USERNAME
    async getUserByUsername({ commit }, username) {
      const action = "getUserByUsername";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/users/username`,
          withCredentials: true,
          params: { username },
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    //  GET USER BY USERNAME
    async getUserOneIdByUsername({ commit }, username) {
      const action = "getUserOneIdByUsername";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/users/oneID`,
          withCredentials: true,
          params: { username },
        });
        commit("SET_LOADING", { action, status: true });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async postNewUserFormOneId({ commit }, paylaod) {
      const action = "postNewUserFormOneId";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.backUrl}/users/oneID`,
          withCredentials: true,
          data: paylaod,
        });
        commit("SET_LOADING", { action, status: true });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getUserByUserId({ commit }, userId) {
      const action = "getUserByUserId";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/users/search`,
          withCredentials: true,
          params: { user_id: userId },
        });
        return data.data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    // UPDATE USER PROFILE
    async patchUserProfile({ commit }, { userId, userUpdate }) {
      const action = "patchUserProfile";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const { data } = await axios({
          method: "PATCH",
          url: `${configuration.backUrl}/users`,
          withCredentials: true,
          params: { user_id: userId },
          headers: { "Content-Type": "multipart/form-data" },
          data: userUpdate,
        });
        return data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async patchUserProfileById({ commit }, { userId, userUpdate }) {
      const action = "patchUserProfileById";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const { data } = await axios({
          method: "PATCH",
          url: `${configuration.backUrl}/users`,
          withCredentials: true,
          data: userUpdate,
          params: { user_id: userId },
        });
        return data;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    //ADD MORE RELATIONSHIP
    async addRelationship({ commit }, relationship) {
      const action = "addRelationship";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.backUrl}/relationship`,
          withCredentials: true,
          data: relationship,
        });

        if (data.success === false) {
          throw new Error(data.message);
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || error.message || `${action} Failed`;
        commit("SET_ERROR", { action, message: errorMessage });
        throw new Error(errorMessage);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    //Delete RELATIONSHIP
    async deleteRelationship({ commit }, relationshipId) {
      const action = "deleteRelationship";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "DELETE",
          url: `${configuration.backUrl}/relationship`,
          withCredentials: true,
          params: { relationship_id: relationshipId },
        });
        return response.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    //GET RELATIONSHIP
    async getRelationship({ commit }, relationType) {
      const action = "getRelationship";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/relationship`,
          withCredentials: true,
        });
        const result = response.data.data;
        commit("SET_RELATIONSHIP", result);
        if (relationType === "student") {
          return result.students;
        } else if (relationType === "parent") {
          return result.parents;
        } else {
          return result;
        }
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    // --------------- CERTIFICATE ---------------------

    //Get Certificate List
    async getUserCertificate({ commit }) {
      const action = "getUserCertificate";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/user-certificate`,
          withCredentials: true,
        });
        const result = response.data.data;
        return result;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async getUserCertificateById({ commit }, userId) {
      const action = "getUserCertificateById";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/user-certificate/user`,
          withCredentials: true,
          params: { user_id: userId },
        });
        const result = response.data.data;
        return result;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    //---------- School And Class ------------

    //Get school list
    async getSchoolList({ commit }) {
      const action = "getSchoolList";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/school`,
        });
        const result = response.data.data;
        commit("SET_SCHOOL", result);
        return result;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    //Get school list
    async getClassList({ commit }) {
      const action = "getClassList";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/class`,
        });
        const result = response.data.data;
        commit("SET_CLASS", result);
        return result;
      } catch (error) {
        commit("SET_ERROR", {
          action,
          message:
            error.response?.data?.message ||
            error.message ||
            `${action} Failed`,
        });
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
  async getUserPortfolio({ commit }) {
      const action = "getUserPortfolio";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });

      try {
        const response = await axios.get(
          `${configuration.backUrl}/portfolio/current-user`,
          {
            withCredentials: true,
            responseType: "blob",
          }
        );

    // success → ได้ไฟล์ pdf
    const pdfBlob = new Blob([response.data], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    return window.open(pdfUrl, "_blank");

  } catch (error) {
    let apiMessage = null;

    // กรณี error response เป็น blob แต่จริง ๆ เป็น JSON message
    if (error.response?.data instanceof Blob) {
        const text = await error.response.data.text(); 
        const json = JSON.parse(text);                 
        apiMessage = json.message;                    
    }

    commit("SET_ERROR", {
      action,
      message:
        apiMessage ||
        error.response?.data?.message ||
        error.message ||
        `${action} Failed`,
    });
    throw error;
  } finally {
    commit("SET_LOADING", { action, status: false });
  }
},
async getUserPortfolioById({ commit }, studentId) {
  const action = "getUserPortfolioById";
  commit("SET_LOADING", { action, status: true });
  commit("SET_ERROR", { action, message: null });

  try {
    const response = await axios({
      method: "GET",
      url: `${configuration.backUrl}/portfolio/student`,
      withCredentials: true,
      params: { student_id: studentId },
      responseType: "blob", // ได้ทั้ง success (pdf) หรือ fail (json error)
    });

    // success → ได้ไฟล์ pdf
    const pdfBlob = new Blob([response.data], { type: "application/pdf" });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    return window.open(pdfUrl, "_blank");
  } catch (error) {
    let apiMessage = null;
    if (error.response?.data instanceof Blob) {
        const text = await error.response.data.text(); 
        const json = JSON.parse(text);                
        apiMessage = json.message;                     
    }

    commit("SET_ERROR", {
      action,
      message:
        apiMessage ||
        error.response?.data?.message ||
        error.message ||
        `${action} Failed`,
    });
    throw error;
  } finally {
    commit("SET_LOADING", { action, status: false });
  }
},


    //--------  Certificate Management ---------------------

    async postCertificate({ commit }, payload) {
      return executeAction({ commit, key: "postCertificate" }, () =>
        profileService.postCertificate(payload)
      );
    },
    async patchCertificate({ commit }, { params, payload }) {
      return executeAction({ commit, key: "patchCertificate" }, () =>
        profileService.patchCertificate(params, payload)
      );
    },
    async deleteCertificate({ commit }, certificateId) {
      return executeAction({ commit, key: "deleteCertificate" }, () =>
        profileService.deleteCertificate(certificateId)
      );
    },
    async getCertificateByUserId({ commit }, userId) {
      return executeAction({ commit, key: "getCertificateByUserId" }, () =>
        profileService.getCertificateByUserId(userId)
      );
    },
    async getCurrentUserCertificate({ commit }) {
      return executeAction({ commit, key: "getCurrentUserCertificate" }, () =>
        profileService.getCurrentUserCertificate()
      );
    },
    async getConsentForAdmin({ commit }, params) {
      return executeAction({ commit, key: "getConsentForAdmin" }, () =>
        profileService.getConsentForAdmin(params)
      );
    },
  },
};

export default profileModules;
